import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {
  Fattura,
  FattureQueryParams,
  ImportFattureResponseDto,
  LottoPassivoSummaryDto
} from '../../core/models/fatture.model';

export const FattureActions = createActionGroup({
  source: 'Fatture',
  events: {
    'Load List': props<{ params?: FattureQueryParams }>(),
    'Load List Success': props<{ items: Fattura[]; totalElements: number; totalPages: number; pageIndex: number }>(),
    'Load List Failure': props<{ error: string }>(),

    'Load Details': props<{ id: number }>(),
    'Load Details Success': props<{ item: Fattura }>(),
    'Load Details Failure': props<{ error: string }>(),

    'Import Xml': props<{ file: File }>(),
    'Import Xml Success': emptyProps(),
    'Import Xml Failure': props<{ error: string }>(),

    'Set Stato Fiscale': props<{ id: number; statoFiscale: string }>(),
    'Set As Costo Fisso': props<{ id: number }>(),

    'Associate Fornitore': props<{ id: number; idFornitore: number }>(),
    'End Fornitore Association': props<{ id: number }>(),

    'Associate Cantiere': props<{ id: number; idCantiere: number }>(),
    'End Cantiere Association': props<{ id: number }>(),

    'Associate Articolo Cantiere': props<{ idArticolo: number; idCantiere: number }>(),
    'End Articolo Cantiere Association': props<{ idArticolo: number }>(),

    'Operation Success': props<{ message: string; reloadId?: number }>(),
    'Operation Failure': props<{ error: string }>(),

    'Load Lotti Sdi To Import': props<{ year: number }>(),
    'Load Lotti Sdi To Import Success': props<{ items: LottoPassivoSummaryDto[] }>(),
    'Load Lotti Sdi To Import Failure': props<{ error: string }>(),

    'Import Lotti Sdi': props<{ lotti: LottoPassivoSummaryDto[] }>(),
    'Import Lotti Sdi Success': props<{ response: ImportFattureResponseDto }>(),
    'Import Lotti Sdi Failure': props<{ error: string }>(),
  },
});
